(() => {
    Dashboard = Dashboard || {};
    Dashboard.Models = Dashboard.Models || {};

    class UrlModel {
        /**
         * Sets the campaign urls based on the current state
         * @param $state {service}
         * @param getParentState {bool}
         */
        initialiseCampaignUrls($state, getParentState) {
            if (getParentState) {
                this.CurrentCampaignsUrl = $state.href(Dashboard.helpers.stateHelper.getParentState($state.current.name));
                this.ActiveCampaignsUrl = $state.href(Dashboard.helpers.stateHelper.getParentState($state.current.name) + '.currentcampaigns');
                this.FinishedCampaignsUrl = $state.href(Dashboard.helpers.stateHelper.getParentState($state.current.name) + '.finishedcampaigns');
                this.CancelledCampaignsUrl = $state.href(Dashboard.helpers.stateHelper.getParentState($state.current.name) + '.cancelledcampaigns');
            } else {
                this.CurrentCampaignsUrl = $state.href($state.current.name);
                this.ActiveCampaignsUrl = $state.href($state.current.name + '.currentcampaigns');
                this.FinishedCampaignsUrl = $state.href($state.current.name + '.finishedcampaigns');
                this.CancelledCampaignsUrl = $state.href($state.current.name + '.cancelledcampaigns');
            }
            return this;
        };

        /**
         * The URL to the current campaigns list based on the current state
         * @type {string}
         */
        CurrentCampaignsUrl = undefined;

        /**
         * The URL to the active campaigns list based on the current state
         * @type {string}
         */
        ActiveCampaignsUrl = undefined;

        /**
         * The URL to the finished campaigns list based on the current state
         * @type {string}
         */
        FinishedCampaignsUrl = undefined;

        /**
         * The URL to the cancelled campaigns list based on the current state
         * @type {string}
         */
        CancelledCampaignsUrl = undefined;
    }

    class CampaignDesignerUrls {
        initialiseUrls($state, getParentState) {
            if (getParentState) {
                this.DraftTemplatesUrl = $state.href(Dashboard.helpers.stateHelper.getParentState($state.current.name));
                this.PublishedTemplatesUrl = $state.href(Dashboard.helpers.stateHelper.getParentState($state.current.name) + '.published');
                this.ArchivedTemplatesUrl = $state.href(Dashboard.helpers.stateHelper.getParentState($state.current.name) + '.archived');
            } else {
                this.DraftTemplatesUrl = $state.href($state.current.name);
                this.PublishedTemplatesUrl = $state.href($state.current.name + '.published');
                this.ArchivedTemplatesUrl = $state.href($state.current.name + '.archived');
            }
            return this;
        }

        DraftTemplatesUrl = undefined;

        PublishedTemplatesUrl = undefined;

        ArchivedTemplatesUrl = undefined;
    }

    Dashboard.Models.UrlModel = UrlModel;
    Dashboard.Models.CampaignDesignerUrls = CampaignDesignerUrls;
})();
